<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="12">
          <validation-observer
            ref="UploadRules"
            tag="form"
          >
            <b-row>
              <b-col md="2">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Doc Type"
                    rules="required"
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <v-select
                        id="DocType"
                        v-model="DocType"
                        :options="DocTypeOptions"
                        label="text"
                        placeholder="Select a type"
                      />
                      <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="9">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Doc"
                    rules="required"
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <b-form-file
                        ref="file"
                        v-model="Doc"
                      />
                      <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>

              </b-col>
              <b-col md="1">
                <b-button
                  v-b-tooltip.hover="'Upload'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="btn-icon mb-1"
                  @click="UploadFile()"
                >
                  <font-awesome-icon
                    :icon="['fas', 'file-upload']"
                    size="lg"
                  /></b-button>&nbsp;
              </b-col>
            </b-row>
          </validation-observer>
        </b-col>
      </b-row>

      <AgGrid
        ref="BookingDocGrid"
        :grid="aggrid"
        @LoadAll="LoadAll"
      />
    </b-card>

  </div>
</template>

<script>
import axios from '@axios'

import { required } from '@validations'
import ViewBtnRenderer from '@core/layouts/ViewBtnRenderers/Booking/BookingDocumentBtnRenderer'
import AgGrid from '@/layouts/components/AgGrid.vue'

export default {
  name: 'BookingDocument',
  components: {
    AgGrid,
  },
  props: {
    bookingId: { type: String, default: '' },
  },
  data() {
    return {
      required,
      aggrid: [],
      Permission: {},
      Role: '',
      OptionalDocs: '',
      OptionalDocsUploaded: '',
      RequiredDocs: '',
      RequiredDocsUploaded: '',
      BKDetail: {
        BookingNumber: '',
        CustomerReference: '',
      },
      DocTypeOptions: [
        { text: 'MBL', value: 'MBL' },
        { text: 'HBL', value: 'HBL' },
        { text: 'Profit Share', value: 'Profit Share' },
        { text: 'Debit Note', value: 'Debit Note' },
        { text: 'AMS', value: 'AMS' },
        { text: 'ISF', value: 'ISF' },
        { text: 'CI', value: 'CI' },
        { text: 'PL', value: 'PL' },
        { text: 'Manifest', value: 'Manifest' },
        { text: 'Load Plan', value: 'Load Plan' },
        { text: 'Consignee Confirmation', value: 'Consignee Confirmation' },
        { text: 'Origin Cost', value: 'Origin Cost' },

      ],
      DocType: '',
      Doc: [],
    }
  },
  beforeMount() {
    axios.defaults.headers.common.DBContext = this.$store.state.user.AppActiveUser.BookingDbContext
    this.aggrid = this.InitGridInstance('BookingDocuments')
    this.aggrid.columnDefs = [
      {
        headerName: '',
        field: 'id',
        filter: false,
        sortable: false,
        autoHeight: true,
        width: 120,
        minWidth: 120,
        maxWidth: 120,
        suppressSizeToFit: true,
        suppressMovable: true,
        pinned: 'left',
        lockPinned: true,
        cellRenderer: 'ViewBtnRenderer',
        enableRowGroup: false,
        enablePivot: false,
      },
      {
        headerName: 'Type', field: 'docType', minWidth: 100, filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Doc Name',
        field: 'docName',
        minWidth: 180,
      },
      { headerName: 'Added By', field: 'addedBy', minWidth: 100 },
      { headerName: 'Added On', field: 'addedOn', minWidth: 100 },

    ]
    this.aggrid.gridOptions.onSortChanged = () => { this.$refs.BookingDocGrid.saveState('BookingDocuments') }
    this.aggrid.gridOptions.onColumnResized = () => { this.$refs.BookingDocGrid.saveState('BookingDocuments') }
    this.aggrid.gridOptions.onColumnMoved = () => { this.$refs.BookingDocGrid.saveState('BookingDocuments') }
    this.aggrid.gridOptions.onFilterChanged = () => { this.$refs.BookingDocGrid.saveState('BookingDocuments') }

    this.aggrid.frameworkComponents = {
      ViewBtnRenderer,
    }
    this.LoadAll()
  },
  methods: {
    LoadAll() {
      Promise.all([this.LoadingStart(), this.LoadBookingDetail()]).then(() => {
        this.LoadDocumentList()
        this.LoadingEnd()
      })
    },
    LoadBookingDetail() {
      return axios.get(`/booking/${this.bookingId}/detail`)
        .then(resp => {
          const response = resp.data
          const respdata = response
          this.BKDetail.BookingNumber = respdata.bookingNumber
          this.BKDetail.CustomerReference = respdata.customerReference
          // Get user role
          this.Role = this.GetUserRole()
          // Get permission
          this.Permission = this.GetUserPermission('Booking')
        })
    },
    LoadDocumentList() {
      axios.get(`/booking/${this.BKDetail.BookingNumber}/documents`)
        .then(rowData => {
          this.aggrid.rowData = rowData.data
        }).then(() => {
          this.$refs.BookingDocGrid.ResetColumns()
        })
    },
    UploadFile() {
      this.$refs.UploadRules.validate().then(result => {
        if (result) {
          this.LoadingStart()
          const formData = new FormData()
          formData.append('file', this.Doc)
          formData.append('BookingNumber', this.BKDetail.BookingNumber)
          formData.append('BookingId', this.bookingId)
          formData.append('DocType', this.DocType.value)
          formData.append('DocName', this.Doc.name)
          axios.post(`/booking/${this.BKDetail.BookingNumber}/documents/upload`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
            .then(() => {
              this.LoadingEnd()
              this.DisplaySuccess('Document has been uploaded.').then(() => {
                this.LoadDocumentList()
                this.DocType = ''
                this.Doc = null
              })
            })
            .catch(e => {
              this.LoadingEnd()
              this.DisplayError('Document cannot be saved.', `${e.response.data.errorCode} / ${e.response.data.errorMessage}`)
            })
        } else {
          this.DisplayError('Cannot upload file.', 'Please check data requirements.')
        }
      })
    },
    Download(DocumentId, FileName) {
      axios.get(`/booking/${this.BKDetail.BookingNumber}/documents/${DocumentId}/download`, {
        responseType: 'blob',
      }).then(response => {
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', FileName)
        link.click()
      })
    },
    Delete(documentId) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.isConfirmed) {
          this.LoadingStart()
          axios.delete(`/booking/${this.BKDetail.BookingNumber}/documents/${documentId}/delete`).then(() => {
            this.LoadingEnd()
            this.DisplaySuccess('Document has been removed.').then(() => {
              this.LoadDocumentList()
            })
          }).catch(e => {
            this.LoadingEnd()
            this.DisplayErrorRemove('Document cannot be removed.', `${e.response.data.errorCode} / ${e.response.data.errorMessage}`)
          })
        }
      })
    },
  },
}
</script>
